import React from "react";
import { Eye, RotateCcw } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Deliveries list. Retry is shown to a Super Admin on FAILED messages. `busy` = { id, action }.
export default function DeliveryRowActions({ row, canManage, busy, onView, onRetry }) {
  const isBusy = (action) => busy?.id === row.id && busy.action === action;
  const anyBusy = busy?.id === row.id;
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View message" icon={Eye} onClick={() => onView(row)} busy={isBusy("view")} disabled={anyBusy} />
      {canManage && row.status === "FAILED" && <IconAction label="Send again" icon={RotateCcw} tone="primary" onClick={() => onRetry([row.id])} busy={isBusy("retry")} disabled={anyBusy} />}
    </div>
  );
}
